import { PURCHASE_ORDER_REQUEST, PURCHASE_ORDER_SUCCESS, PURCHASE_ORDER_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: true,
  action: "Purchase Action",
  result: null,
  msg: "",
  error: "",
};

const PurchaseOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case PURCHASE_ORDER_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case PURCHASE_ORDER_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case PURCHASE_ORDER_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default PurchaseOrderReducer;
